export const FETCH_FOLLOW_UPS = 'FOLLOW_UPS/FETCH_REQUEST';
export const FETCH_FOLLOW_UPS_SUCCESS = 'FOLLOW_UPS/FETCH_SUCCESS';

// Send follow-up
export const SEND_FOLLOW_UP = 'FOLLOW_UP/SEND_REQUEST';
export const SEND_FOLLOW_UP_SUCCESS = 'FOLLOW_UP/SEND_SUCCESS';

// Unscheduled follow-up
export const UNSCHEDULE_FOLLOW_UP = 'FOLLOW_UP/UNSCHEDULE_REQUEST';
export const UNSCHEDULE_FOLLOW_UP_SUCCESS = 'FOLLOW_UP/UNSCHEDULE_SUCCESS';

// Schedule follow-up
export const SCHEDULE_FOLLOW_UP = 'FOLLOW_UP/SCHEDULE_REQUEST';
export const SCHEDULE_FOLLOW_UP_SUCCESS = 'FOLLOW_UP/SCHEDULE_SUCCESS';

// Models
export const GET_FOLLOW_UP_MODEL_REQUEST = 'INTERVENTION/FOLLOW_UP_MODEL/REQUEST';
export const GET_FOLLOW_UP_MODEL_SUCCESS = 'INTERVENTION/FOLLOW_UP_MODEL/SUCCESS';
export const GET_FOLLOW_UP_MODEL_FAILURE = 'INTERVENTION/FOLLOW_UP_MODEL/FAILURE';

// Filters actions
export const SET_FOLLOW_UP_DASHBOARD_FILTER = 'FOLLOW_UP/DASHBOARD/FILTERS/SET_ONE';
export const SET_FOLLOW_UP_DASHBOARD_FILTERS = 'FOLLOW_UP/DASHBOARD/FILTERS/SET_MANY';
export const REMOVE_FOLLOW_UP_DASHBOARD_FILTER = 'FOLLOW_UP/DASHBOARD/FILTERS/REMOVE_ONE';
export const CLEAR_FOLLOW_UP_DASHBOARD_FILTER = 'FOLLOW_UP/DASHBOARD/FILTERS/CLEAR';

// Persisted filters
export const PERSISTED_ACTION_TYPES = [
  SET_FOLLOW_UP_DASHBOARD_FILTER,
  SET_FOLLOW_UP_DASHBOARD_FILTERS,
  REMOVE_FOLLOW_UP_DASHBOARD_FILTER,
  CLEAR_FOLLOW_UP_DASHBOARD_FILTER,
];
